import clsx from "clsx";
import { Text } from "./base";

type AgentSessionStatusPillProps = {
  status: string;
};

export const AgentSessionStatusPill = ({ status }: AgentSessionStatusPillProps) => {
  return (
    <Text
      className={clsx(
        "w-auto px-2 py-0.5 rounded-full text-xs",
        status === "completed" && "bg-success/10 dark:bg-success/20 text-success-dark dark:text-success-light",
        status === "in_progress" && "bg-info/10 dark:bg-info/20 text-info-dark dark:text-info-light",
        status === "failed" && "bg-error/10 dark:bg-error/20 text-error-dark dark:text-error-light",
      )}
    >
      {status === "completed" ? "Completed" : status === "in_progress" ? "In Progress" : "Failed"}
    </Text>
  );
};
